import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { utc } from "moment";
import * as qs from "query-string";
import { Link } from "react-router-dom";
import {
    faDownload,
    faLink,
    faTasks,
    faBullseye,
    faComment,
    faListOl,
    faChartLine
} from "@fortawesome/pro-solid-svg-icons";
import { faUsers } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PageLabel from "../PageLabel";
import ResultsDownloader from "./ResultsDownloader";
import Truncated from "../Truncated";
import { PAGE_LABELS } from "../../modules/pages/constants";
import Config from "../../config";
import styles from "../../styles/components/ResultsSideNav.css";
import * as results from "../../modules/results";

export class ResultsSideNav extends PureComponent {
    generateUrl(target) {
        const search = qs.stringify(this.props.queryString);
        return {
            pathname: `${this.props.resultsBaseUrl}/${target}`,
            search: search && `?${search}`
        };
    }

    generatePages() {
        return (
            <ul>
                {this.props.pages.map((page, index) => (
                    <li
                        key={page.id}
                        className={[
                            styles.navItem,
                            styles.link,
                            styles.pageItem,
                            page.isSelected ? styles.isSelected : ""
                        ].join(" ")}
                        onClick={() => this.props.selectPage(page.id)}
                    >
                        <PageLabel
                            className={styles.pageIcon}
                            label={PAGE_LABELS[index]}
                        />
                        <Truncated className={styles.label} maxLength={20}>
                            {page.name}
                        </Truncated>
                    </li>
                ))}
            </ul>
        );
    }

    generateLink(label, target, iconName, withPages = false) {
        const isSelected = this.props.location.pathname.indexOf(target) > -1;
        const classNames = `${styles.link} ${isSelected && styles.isSelected}`;
        const targetUrl = this.generateUrl(target);
        return (
            <li className={styles.navItem} key={`navItem-${target}`}>
                <Link className={classNames} to={targetUrl}>
                    <div className={styles.icon}>
                        <FontAwesomeIcon icon={iconName} />
                    </div>
                    <p className={styles.label}>{label}</p>
                </Link>
                {withPages &&
                    this.props.pages.length > 1 &&
                    isSelected &&
                    this.generatePages()}
            </li>
        );
    }

    render() {
        const {
            pages,
            wevo,
            isShareLink,
            hasKeyFindings,
            hasExpectations
        } = this.props;
        const hasShareLinks = wevo.shareLinks && wevo.shareLinks.length > 0;
        const testDetailsLink = `${Config.general().betaHost}/wevo/${
            wevo.id
        }/details`;

        return (
            <div className={styles.sideNav}>
                <ul className={styles.links}>
                    {pages.length > 1 &&
                        this.generateLink(
                            "Compare",
                            "compare-pages",
                            faChartLine
                        )}
                    {hasKeyFindings &&
                        this.generateLink(
                            "Key Findings",
                            "key-findings",
                            faListOl,
                            true
                        )}
                    {this.generateLink("Drivers", "drivers", faBullseye, true)}
                    {this.generateLink(
                        "Audience Reactions",
                        "likes-and-dislikes",
                        faComment,
                        true
                    )}
                    {Config.features().audienceExpectations &&
                        hasExpectations &&
                        this.generateLink(
                            "Audience Expectations",
                            "expectations",
                            faUsers,
                            true
                        )}

                    {!isShareLink && (
                        <div
                            key="test-details-button"
                            className={styles.navItem}
                        >
                            <a
                                className={`${styles.link} ${styles.startSection}`}
                                href={testDetailsLink}
                                target="_blank"
                            >
                                <div className={styles.icon}>
                                    <FontAwesomeIcon icon={faTasks} />
                                </div>
                                <p className={styles.label}>
                                    View Test Details
                                </p>
                            </a>
                        </div>
                    )}

                    <div className={styles.navItem}>
                        <button
                            className={`${styles.link} ${isShareLink &&
                                styles.startSection}`}
                            disabled={!hasShareLinks}
                            onClick={this.props.openShareLinkModal}
                        >
                            <div className={styles.icon}>
                                <FontAwesomeIcon icon={faLink} />
                            </div>
                            <p className={styles.label}>Share Test</p>
                        </button>
                    </div>

                    {!isShareLink && (
                        <div className={styles.navItem}>
                            <ResultsDownloader
                                className={styles.link}
                                wevoId={this.props.wevo.id}
                            >
                                <div className={styles.icon}>
                                    <FontAwesomeIcon icon={faDownload} />
                                </div>
                                <p className={styles.label}>Download Results</p>
                            </ResultsDownloader>
                        </div>
                    )}
                </ul>

                <div className={styles.resultsNavBottom}>
                    <p className={styles.completed}>
                        Completed:{" "}
                        {wevo.dateCompleted && getHumanTime(wevo.dateCompleted)}
                    </p>
                </div>
            </div>
        );
    }
}

/* Helpers */
const getHumanTime = timestamp => {
    return utc(timestamp)
        .local()
        .format("MM/DD/YYYY");
};

function mapStateToProps(state, props) {
    const { location } = state.router;
    const { queryString } = state;

    const wevo = props.wevo || null;
    const pages = wevo
        ? wevo.pages.map(page => ({
              ...page,
              isSelected: page.id === props.selectedPageId
          }))
        : null;

    return {
        wevo,
        pages,
        location,
        queryString
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openShareLinkModal: () => dispatch(results.openShareLinkModal()),
        selectPage: pageId => dispatch(results.selectPage(pageId))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResultsSideNav);



// WEBPACK FOOTER //
// ./src/components/Results/ResultsSideNav.js